"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarButtonType = void 0;
var SidebarButtonType;
(function (SidebarButtonType) {
    SidebarButtonType["Tracks"] = "tracks";
    SidebarButtonType["Playlists"] = "playlists";
})(SidebarButtonType || (exports.SidebarButtonType = SidebarButtonType = {}));
